/**
 * **새 계정의 처음 비밀번호를 한 번 보여 주기** — 매장·사업장 등록 응답(`POST /store`·`POST /store/mng`·`POST /cust` →
 * `{accountId, initialPassword}`)의 무작위 초기값은 **이 응답에 한 번뿐**이다(appserver 대응방안 결정 47 ③). 등록 성공 뒤 화면 갱신보다
 * 먼저 등록한 사람에게 보인다. 의존성 없는 순수 모듈이다 — 보이는 효과(Element `$alert`)는 부르는 자리가 넘긴다.
 *
 * 콜팝 신규 매장 등록은 응답 모양이 달라(`storeMngAccountId`·`initialPassword`) 그 결과 카드(`callpopOrg.registerResultAccounts`)가 보인다.
 */

export const INITIAL_ACCOUNT_TEXT = Object.freeze({
  title: '새 계정의 처음 비밀번호',
  confirm: '확인',
})

/** 등록 응답 → 새 계정. 두 칸이 다 있을 때만(옛 서버의 빈 응답·수정 응답이면 `null`) */
export function initialAccountOf(data) {
  const row = data && typeof data === 'object' ? data : {}
  if (!hasText(row.accountId) || !hasText(row.initialPassword)) return null

  return { accountId: row.accountId, password: row.initialPassword }
}

/** 보일 말 — 아이디 뒤에 받침 따라 갈리는 조사를 붙이지 않는다 */
export function initialAccountNotice(account) {
  if (!account) return null

  return {
    title: INITIAL_ACCOUNT_TEXT.title,
    message:
      `아이디 ${account.accountId} · 처음 비밀번호 ${account.password} — ` +
      '이 창을 닫으면 다시 볼 수 없으니 지금 적어 두고 점주에게 전해 주세요.',
  }
}

/**
 * 등록 응답에 새 계정이 있으면 한 번 알린다.
 *
 * @param {function(string, string, object): *} alert 알림 효과(Element `this.$alert` — 닫기로 끝나도 거절이 남지 않게 받아 둔다)
 * @param {*} data 등록 응답 본문
 * @returns {boolean} 알렸는가
 */
export function announceInitialAccount(alert, data) {
  const notice = initialAccountNotice(initialAccountOf(data))
  if (!notice) return false

  const shown = alert(notice.message, notice.title, { confirmButtonText: INITIAL_ACCOUNT_TEXT.confirm })
  if (shown && typeof shown.catch === 'function') shown.catch(() => {})

  return true
}

function hasText(value) {
  return typeof value === 'string' && value.trim() !== ''
}
